import { IgGrayPrimitives } from "@intelligems/ig-design-tokens";
import { Editor } from "@tiptap/react";

export function useRichEditorState(editor: Editor | null) {
  return {
    undoEnabled: editor?.can().undo() ?? false,
    redoEnabled: editor?.can().redo() ?? false,
    fontSize: (editor?.getAttributes("textStyle").fontSize as string) ?? "12px",
    color:
      (editor?.getAttributes("textStyle").color as string) ??
      IgGrayPrimitives["A600"],
    bold: editor?.isActive("bold") ?? false,
    italic: editor?.isActive("italic") ?? false,
    underline: editor?.isActive("underline") ?? false,
  };
}
